export default __webpack_public_path__ + "static/media/1200px-Saddleback_College_logo.svg.c0e2ff68.png";